import { render, staticRenderFns } from "./StarPrinterPrinterInputs.vue?vue&type=template&id=6caefccb&"
import script from "./StarPrinterPrinterInputs.vue?vue&type=script&lang=ts&"
export * from "./StarPrinterPrinterInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports